// extracted by mini-css-extract-plugin
export default {"container":"ChangeResultStatusBox_container__fXOVo"};